

export function getPhoneCountry() {
    const countryCodePhone = sessionStorage.getItem("country_iso2") != null &&
    sessionStorage.getItem("country_iso2") != ""
        ? sessionStorage
            .getItem("country_iso2")
            .toLowerCase()
        : "sg"

    return countryCodePhone;
}